import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  selector: 'display-input',
  imports: [CommonModule, MatFormFieldModule, MatInputModule],
  templateUrl: './display-input.component.html',
  styleUrl: './display-input.component.scss',
})
export class DisplayInputComponent {
  @Input() title: string | undefined = '';
  @Input() value: string | undefined = '';
  @Input() class: string = '';
}
